export const getPayPalLocaleFromLocaleCode = (localeCode: string) => {
  switch (localeCode) {
    case 'ar_EG':
    case 'bg_BG':
    case 'zh_CN':
    case 'zh_TW':
    case 'cs_CZ':
    case 'da_DK':
    case 'nl_BE':
    case 'nl_NL':
    case 'en_AU':
    case 'en_CA':
    case 'en_GB':
    case 'en_HK':
    case 'en_IE':
    case 'en_IL':
    case 'en_MY':
    case 'en_NZ':
    case 'en_PH':
    case 'en_SA':
    case 'en_SG':
    case 'en_ZA':
    case 'en_AE':
    case 'en_US':
    case 'et_EE':
    case 'fi_FI':
    case 'fr_FR':
    case 'de_AT':
    case 'de_DE':
    case 'de_CH':
    case 'el_GR':
    case 'hu_HU':
    case 'in_ID':
    case 'it_IT':
    case 'ja_JP':
    case 'ko_KR':
    case 'lv_LV':
    case 'lt_LT':
    case 'no_NO':
    case 'pl_PL':
    case 'pt_PT':
    case 'pt_BR':
    case 'ro_RO':
    case 'ru_RU':
    case 'sk_SK':
    case 'es_MX':
    case 'es_ES':
    case 'sv_SE':
    case 'th_TH':
    case 'tr_TR':
    case 'vi_VN':
      return localeCode;
    case 'be_BY':
      return 'en_BY';
    case 'is_IS':
      return 'en_IS';
    case 'sr_RS':
      return 'en_RS';
    case 'uk_UA':
      return 'en_UA';
    default:
      return 'en_GB';
  }
};
